import { Button } from "components";
import useAuthUser from "hooks/auth-user";
import useLanguage from "hooks/language";
import { PREP_STATUS } from "models/prep-status";
import { Loader } from "react-feather";
import { useStopPrepService } from "../../utils/context";
import { PrEPStatusHistory } from "../prep-status-history";
import warnIcon from "../../../../../assets/images/warn-icon.png";
import styles from "./prep-status-tab.module.css";

/**
 * The contents of the PrEP status tab depends on the eligibility of the user,
 * taken from their last PrEP status.
 */
export const PrEPStatusTab: React.FunctionComponent = () => {
    const [user] = useAuthUser();

    if (!user) {
        return <Loader className={`spinorama ${styles.loader}`} />;
    } else if (user.lastPrepStatus?.status === PREP_STATUS.ELIGIBLE) {
        return <ActiveSection />;
    } else {
        return <PrepSuspendedBanner />;
    }
};

/**
 * This section is displayed if the user's latest status is exactly ELIGIBLE.
 * Here they can see they status history and a stop button.
 */
const ActiveSection = () => {
    const {
        translations: {
            prepSection: {
                prepStatus: { active: t },
            },
        },
    } = useLanguage();

    const [user] = useAuthUser();
    const stopPrepService = useStopPrepService();

    const onClick = async () => {
        await stopPrepService();
    };

    return (
        <section className={`container ${styles.status} ${styles.active}`}>
            <h2>{t.title}</h2>
            <hr />
            <p>{t.description}</p>
            <Button
                type="secondary"
                className={styles.stopBtn}
                onClick={onClick}
            >
                {t.btn}
            </Button>
            <h3>{t.history}</h3>
            <hr />
            {user && <PrEPStatusHistory />}
        </section>
    );
};

function PrepSuspendedBanner(): JSX.Element {
    const {
        translations: {
            prepSection: {
                prepStatus: { suspended: t },
            },
        },
    } = useLanguage();
    return (
        <div className={styles.prepSuspendedBanner}>
            <div className={styles.innerContainer}>
                <h2>
                    <img src={warnIcon} />
                    {t.title}
                </h2>
                <p>{t.description}</p>
                <p>
                    <strong>{t.existingPatient.title}</strong>{" "}
                    {t.existingPatient.text}
                </p>
            </div>
        </div>
    );
}
